// extracted by mini-css-extract-plugin
export default {"buttonsMenu":"HeaderFixedButtons-module__buttonsMenu__EXD0q","buttonsMenuAlignedLeft":"HeaderFixedButtons-module__buttonsMenuAlignedLeft__ZlTmz"};